import React from "react";

const CandidateDetailsTabsSkeleton = () => {
  return (
    <div>
      <div className="flex flex-col gap-tm2 my-tsm">
        <div className="flex gap-2">
          <div className="w-32 h-6 rounded-[44px] skeleton-bg 2"></div>
          <div className="w-32 h-6 rounded-[44px] skeleton-bg 2"></div>
        </div>

        <div className="flex flex-col card gap-tsm p-tm2">
          <p className="w-20 h-8 rounded-full skeleton-bg"></p>
          <p className="w-48 h-6 rounded-full skeleton-bg"></p>

          <div className="flex flex-col gap-2">
            <p className="w-20 h-8 rounded-2xl skeleton-bg"></p>
            <div className="flex gap-2 ml-2">
              <div className="w-10 h-6 rounded-sm skeleton-bg"></div>
              <div className="w-10 h-6 rounded-sm skeleton-bg"></div>
              <div className="w-10 h-6 rounded-sm skeleton-bg"></div>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <p className="w-20 h-8 rounded-2xl skeleton-bg"></p>
            <div className="flex gap-2 ml-2">
              <div className="w-10 h-6 rounded-sm skeleton-bg"></div>
              <div className="w-10 h-6 rounded-sm skeleton-bg"></div>
              <div className="w-10 h-6 rounded-sm skeleton-bg"></div>
            </div>
          </div>
        </div>

        <div className="flex flex-col p-tm2 card gap-tsm">
          <div className="w-32 h-6 rounded-[44px] skeleton-bg 2"></div>
          <div className="w-full h-32 navigation-bg"></div>
        </div>
      </div>
    </div>
  );
};

export default CandidateDetailsTabsSkeleton;
